var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import WatchListContext from "@frameworks/web/components/features/WatchList/WatchListContext";
var SearchBar = function (props) {
    var _a, _b, _c;
    var device = DeviceContext();
    var _d = __read(useState((props === null || props === void 0 ? void 0 : props.focusOnLoad) ? props === null || props === void 0 ? void 0 : props.focusOnLoad : false), 2), openSearch = _d[0], setOpenSearch = _d[1];
    var _e = __read(useState((props === null || props === void 0 ? void 0 : props.defaultValue) ? props === null || props === void 0 ? void 0 : props.defaultValue : ""), 2), searchValue = _e[0], setSearchValue = _e[1];
    var _f = props.showBackArrow, showBackArrow = _f === void 0 ? true : _f, _g = props.searchIcon, searchIcon = _g === void 0 ? "edel-icon-search1" : _g, _h = props.closeIcon, closeIcon = _h === void 0 ? "edel-icon-close" : _h, _j = props.enableOnChangeFunctionInUseEffect, enableOnChangeFunctionInUseEffect = _j === void 0 ? true : _j;
    var _k = React.useContext(WatchListContext) || {}, _l = _k.watchListSearchValue, watchListSearchValue = _l === void 0 ? "" : _l, _m = _k.setWatchListSearchValue, setWatchListSearchValue = _m === void 0 ? function () { } : _m;
    var handleBlur = function () {
        if (!searchValue)
            setSearchValue("");
        setOpenSearch(false);
        props.onBlur && props.onBlur();
    };
    // useEffect(() => {
    //   if (props.onCallbackFunction ) {
    //     props.onCallbackFunction(searchValue);
    //   }
    // }, [searchValue, props.defaultValue]);
    useEffect(function () {
        if (watchListSearchValue === "") {
            setSearchValue("");
        }
    }, [watchListSearchValue]);
    useEffect(function () {
        if (searchValue != props.searchKey) {
            setSearchValue(props.searchKey);
        }
    }, [props.searchKey]);
    useEffect(function () {
        if (props.onCallbackFunction &&
            (props === null || props === void 0 ? void 0 : props.searchKey) &&
            enableOnChangeFunctionInUseEffect) {
            props.onCallbackFunction(props.searchKey);
        }
    }, [props === null || props === void 0 ? void 0 : props.searchKey]);
    return (React.createElement("div", { className: props.parentClassName ? props.parentClassName : "" },
        React.createElement("div", { className: "common-search-bar d-flex align-items-center ".concat(props.searchBarBackground, " ").concat(openSearch
                ? (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0
                    ? "open-search"
                    : "highlight-search"
                : "") },
            openSearch && showBackArrow && (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0 ? (React.createElement("label", { htmlFor: "focus-input", onMouseDown: function () {
                    setSearchValue((props === null || props === void 0 ? void 0 : props.defaultValue) || "");
                    (props === null || props === void 0 ? void 0 : props.onBack) && props.onBack();
                } },
                React.createElement("span", { className: "edel-icon-left-arrow hand_cursor ".concat((_a = props.iconColors) !== null && _a !== void 0 ? _a : "") }))) : (
            //  {/*  <label htmlFor="focus-input">
            //   <span
            //     className="edel-icon-left-arrow hand_cursor"
            //     onClick={() => {
            //       setSearchValue("");
            //       props.onCallbackFunction("");
            //       setOpenSearch(false);
            //       props?.onBack && props.onBack();
            //     }}
            //   ></span>
            // </label>  */}
            React.createElement("label", null,
                React.createElement("i", { className: "".concat(searchIcon, " ").concat((_b = props.iconColors) !== null && _b !== void 0 ? _b : ""), onClick: function () {
                        if (props === null || props === void 0 ? void 0 : props.disabled)
                            return;
                        setOpenSearch(true);
                    } }))),
            React.createElement("input", { autoFocus: props === null || props === void 0 ? void 0 : props.focusOnLoad, autoComplete: props === null || props === void 0 ? void 0 : props.autoComplete, disabled: props === null || props === void 0 ? void 0 : props.disabled, className: openSearch && (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0
                    ? props.openInputBackground
                    : props.searchBarBackground, id: "focus-input", type: "search", placeholder: (device === null || device === void 0 ? void 0 : device.isDesktop) ? props.deskPlaceHolder : props.mobPlaceHolder, value: searchValue, onClick: function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    (props === null || props === void 0 ? void 0 : props.setOnFocusa) && (props === null || props === void 0 ? void 0 : props.setOnFocusa(true));
                }, onChange: function (e) {
                    setSearchValue(e.target.value);
                    props.onCallbackFunction(e.target.value);
                }, onFocus: function () {
                    setOpenSearch(true);
                    props.onFocus && (props === null || props === void 0 ? void 0 : props.onFocus());
                }, onBlur: handleBlur }),
            openSearch && (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0 && (React.createElement("label", { htmlFor: "focus-input" },
                React.createElement("i", { className: "".concat(closeIcon, " txt_secondary-gray hand_cursor ").concat((_c = props.iconColors) !== null && _c !== void 0 ? _c : ""), onMouseDown: function () {
                        setSearchValue("");
                        props.onCallbackFunction("");
                        props.onClose && props.onClose();
                    } }))))));
};
export default SearchBar;
